export default {"src":"/_next/static/media/earnFromBlogging.cdde8f28.svg","height":803,"width":1118,"blurWidth":0,"blurHeight":0};